import RequestService from '../request-service';

export default class LoadBetslipRequestService extends RequestService {
  constructor() {
    super();
    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.LoadBetslip;
    /**
     * Set request method
     * @type {string}
     */
    this.method = 'post';
    /**
     * Get parameters
     */
    this.postParams = {
      ReservationCode: '',
    };
    this.headers = null;
  }
}
